const OurTeam = {
    OurTeam:[
        {
            id:1,
            name:'Vinsensius Jehaut',
            title:'Senior Travel Document',
            desc:'Experienced since 2005 until now',
            path:'vin.webp'
        },
        {
            id:2,
            name:'Valentino',
            title:'Operational Manager',
            desc:'tino.pw ',
            path:'valennew.webp'
        }
    ]
}
export default OurTeam